import { render, staticRenderFns } from "./SetRecordInformation.vue?vue&type=template&id=f9f7156a&scoped=true&"
import script from "./SetRecordInformation.vue?vue&type=script&lang=js&"
export * from "./SetRecordInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f7156a",
  null
  
)

export default component.exports